import { QueryMetadata } from "./query-metadata";

export class UserQuery {
    Name: string;
    Email: string;
    Role: string;
    IncludeInactive: boolean;
    Metadata: QueryMetadata;
}
